import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Modal,
  Section,
  Select,
  Title,
} from "@allxsmith/bestax-bulma";

import React, { useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import {useReactToPrint} from "react-to-print";
import PrintJobQuote from "./PrintJobQuote";

export default function PrintJobQuoteOptionsModal({ open, setOpen, data }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({contentRef: componentRef})

  const [chargeableSelected, setChargeableSelected] = useState(true);

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={() => setOpen(false)}>
      <Modal.Content>
        <Section style={{ backgroundColor: "grey" }}>
          <Box>
            <Title>Print Options</Title>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Type</label>
                    <Select
                      onChange={e =>
                        setChargeableSelected(JSON.parse(e.target.value))
                      }
                      name="type"
                      value={chargeableSelected}
                    >
                      <option value={true}>Customer 2</option>
                      <option value={false}>Customer</option>
                    </Select>
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                <Button color="warning" onClick={handlePrint} isFullWidth>
                  Print Workshop Quote Sheet
                </Button>
              </Column>
              <Column>
                <Button color="info" onClick={() => setOpen(false)} isFullWidth>
                  Cancel
                </Button>
              </Column>
            </Columns>
          </Box>
        </Section>
      </Modal.Content>
      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          <PrintJobQuote
            chargeable={chargeableSelected}
            data={data}
          />
        </div>
      </div>
    </Modal>
  );
}
